import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container mt-3" }
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "accordion-item" }
const _hoisted_4 = ["id"]
const _hoisted_5 = ["data-bs-target", "aria-controls"]
const _hoisted_6 = { class: "d-flex justify-content-between align-items-center w-100" }
const _hoisted_7 = { class: "hidden-xs" }
const _hoisted_8 = { class: "season-dates" }
const _hoisted_9 = { class: "btn-group me-3 icon-group" }
const _hoisted_10 = ["data-bs-target"]
const _hoisted_11 = ["data-bs-target"]
const _hoisted_12 = {
  class: "fa fa-clock-o text-danger icon-medium",
  role: "button",
  title: "Season Expired"
}
const _hoisted_13 = ["id", "aria-labelledby", "data-bs-parent"]
const _hoisted_14 = { class: "accordion-body" }
const _hoisted_15 = ["id"]
const _hoisted_16 = { class: "accordion-item" }
const _hoisted_17 = ["data-bs-target", "aria-controls"]
const _hoisted_18 = ["id", "aria-labelledby", "data-bs-parent"]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "col col-3 col-xl-4 align-middle channel-name" }
const _hoisted_22 = { class: "col col-2 col-xl-3 d-flex align-items-center" }
const _hoisted_23 = ["onUpdate:modelValue"]
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "col col-auto d-flex align-items-center gap-3" }
const _hoisted_26 = { class: "price-adjustment-cell" }
const _hoisted_27 = { class: "input-group" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["value", "onInput"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "percent-explanation" }
const _hoisted_32 = ["id"]
const _hoisted_33 = { class: "accordion-item" }
const _hoisted_34 = ["data-bs-target", "aria-controls"]
const _hoisted_35 = ["id", "aria-labelledby", "data-bs-parent"]
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { class: "col col-3 col-xl-4 align-middle channel-name" }
const _hoisted_39 = { class: "col col-2 col-xl-3 d-flex align-items-center" }
const _hoisted_40 = ["onUpdate:modelValue"]
const _hoisted_41 = ["value"]
const _hoisted_42 = { class: "col col-auto d-flex align-items-center gap-3" }
const _hoisted_43 = { class: "price-adjustment-cell" }
const _hoisted_44 = { class: "input-group" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["value", "onInput"]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = { class: "percent-explanation" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SeasonsCopyComponent = _resolveComponent("SeasonsCopyComponent")!
  const _component_SeasonsEditComponent = _resolveComponent("SeasonsEditComponent")!
  const _component_QuickAssignModal = _resolveComponent("QuickAssignModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "accordion",
      id: `season-${_ctx.season.id}`
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", {
          class: "accordion-header",
          id: `heading-${_ctx.season.id}`
        }, [
          _createElementVNode("button", {
            class: "accordion-button collapsed",
            type: "button",
            "data-bs-toggle": "collapse",
            "data-bs-target": `#collapse-${_ctx.season.id}`,
            "aria-controls": `collapse-${_ctx.season.id}`
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", null, [
                _createElementVNode("strong", _hoisted_7, _toDisplayString(_ctx.season.description), 1),
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.formatDate(_ctx.season.startDate)) + " - " + _toDisplayString(_ctx.formatDate(_ctx.season.endDate)), 1)
              ])
            ])
          ], 8, _hoisted_5),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", null, [
              _withDirectives(_createElementVNode("i", {
                class: "fa fa-bolt icon-medium hover-yellow",
                role: "button",
                "data-bs-toggle": "modal",
                title: "Lightning Action",
                "data-bs-target": `#quickAssignModal-${_ctx.season.id}`
              }, null, 8, _hoisted_10), [
                [_vShow, !_ctx.expiredSeason(_ctx.season.endDate)]
              ])
            ]),
            _createElementVNode("span", null, [
              _createElementVNode("i", {
                class: "fa fa-copy icon-medium hover-green",
                role: "button",
                "data-bs-toggle": "modal",
                "data-bs-target": `#copySeasonModal-${_ctx.season.id}`,
                title: "Copy Season"
              }, null, 8, _hoisted_11)
            ]),
            _createElementVNode("span", null, [
              _withDirectives(_createElementVNode("i", {
                class: "fa fa-pencil",
                role: "button",
                title: "Edit Season",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.editSeason && _ctx.editSeason(...args)))
              }, null, 512), [
                [_vShow, !_ctx.expiredSeason(_ctx.season.endDate)]
              ])
            ]),
            _createElementVNode("span", {
              class: _normalizeClass(`${_ctx.isSeasonChannelsModified ? 'visible-always' : ''}`)
            }, [
              _withDirectives(_createElementVNode("i", {
                class: _normalizeClass(`fa fa-save icon-medium ${
                  _ctx.isSeasonChannelsModified ? 'color-blue' : 'color-gray'
                }`),
                role: "button",
                title: "Save Season",
                onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveSeason && _ctx.saveSeason(...args)), ["stop","prevent"]))
              }, null, 2), [
                [_vShow, !_ctx.expiredSeason(_ctx.season.endDate)]
              ])
            ], 2),
            _createElementVNode("span", null, [
              _withDirectives(_createElementVNode("i", _hoisted_12, null, 512), [
                [_vShow, _ctx.expiredSeason(_ctx.season.endDate)]
              ])
            ]),
            _createElementVNode("span", null, [
              _withDirectives(_createElementVNode("i", {
                class: "fa fa-trash icon-medium hover-red",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.deleteSeason && _ctx.deleteSeason(...args))),
                role: "button",
                title: "Delete Season"
              }, null, 512), [
                [_vShow, !_ctx.expiredSeason(_ctx.season.endDate)]
              ])
            ])
          ])
        ], 8, _hoisted_4),
        _createElementVNode("div", {
          id: `collapse-${_ctx.season.id}`,
          class: "accordion-collapse collapse",
          "aria-labelledby": `heading-${_ctx.season.id}`,
          "data-bs-parent": `#season-${_ctx.season.id}`
        }, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", {
              class: "accordion mb-4",
              id: `yourChannels-listed${_ctx.season.id}`
            }, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("button", {
                  class: "accordion-button channel-header",
                  type: "button",
                  "data-bs-toggle": "collapse",
                  "data-bs-target": `#collapseYourChannels${_ctx.season.id}`,
                  "aria-expanded": "true",
                  "aria-controls": `collapseYourChannels${_ctx.season.id}`
                }, [...(_cache[5] || (_cache[5] = [
                  _createTextVNode(" Your Channels ", -1),
                  _createElementVNode("i", { class: "fa fa-chevron-down ms-2" }, null, -1)
                ]))], 8, _hoisted_17),
                _createElementVNode("div", {
                  id: `collapseYourChannels${_ctx.season.id}`,
                  class: "accordion-collapse collapse show",
                  "aria-labelledby": `headingYourChannels${_ctx.season.id}`,
                  "data-bs-parent": `#yourChannels-listed${_ctx.season.id}`
                }, [
                  (_ctx.ownedChannels.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, " No channels available. "))
                    : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ownedChannels, (seasonChannel) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "row py-3",
                            key: seasonChannel.channel?.id
                          }, [
                            _createElementVNode("div", _hoisted_21, _toDisplayString(seasonChannel.channel?.description), 1),
                            _createElementVNode("div", _hoisted_22, [
                              _withDirectives(_createElementVNode("select", {
                                class: "form-select",
                                "onUpdate:modelValue": ($event: any) => ((_ctx.getChannelConfig(seasonChannel.channel!.id!).strategyId) = $event),
                                onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.changeSeason && _ctx.changeSeason(...args)))
                              }, [
                                _cache[6] || (_cache[6] = _createElementVNode("option", { value: 0 }, "No strategy applied", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.strategies, (strategy) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: strategy.id,
                                    value: strategy.id
                                  }, _toDisplayString(strategy.name), 9, _hoisted_24))
                                }), 128))
                              ], 40, _hoisted_23), [
                                [_vModelSelect, _ctx.getChannelConfig(seasonChannel.channel!.id!).strategyId]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("div", _hoisted_26, [
                                _createElementVNode("div", _hoisted_27, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["input-group-text clickable justify-content-center", {
                                active: !seasonChannel.usePercentage,
                              }]),
                                    onClick: ($event: any) => (_ctx.toggleUsePercentage(seasonChannel, false))
                                  }, "$", 10, _hoisted_28),
                                  _createElementVNode("input", {
                                    type: "text",
                                    class: _normalizeClass(["form-control", {
                                'text-end': seasonChannel.usePercentage,
                                'text-start': !seasonChannel.usePercentage,
                              }]),
                                    value: _ctx.getChannelAdjustmentValue(seasonChannel),
                                    onInput: ($event: any) => (
                                _ctx.updateChannelAdjustment(seasonChannel, $event)
                              )
                                  }, null, 42, _hoisted_29),
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["input-group-text clickable justify-content-center", {
                                active: seasonChannel.usePercentage,
                              }]),
                                    onClick: ($event: any) => (_ctx.toggleUsePercentage(seasonChannel, true))
                                  }, "%", 10, _hoisted_30)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_31, [
                                _createElementVNode("label", null, [
                                  _createElementVNode("em", null, _toDisplayString(_ctx.getAdjustmentValueExplanation(seasonChannel)), 1)
                                ])
                              ])
                            ])
                          ]))
                        }), 128))
                      ]))
                ], 8, _hoisted_18)
              ])
            ], 8, _hoisted_15),
            _createElementVNode("div", {
              class: "accordion",
              id: `thirdPartyChannels-listed${_ctx.season.id}`
            }, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("button", {
                  class: "accordion-button channel-header",
                  type: "button",
                  "data-bs-toggle": "collapse",
                  "data-bs-target": `#collapseThirdPartyChannels${_ctx.season.id}`,
                  "aria-expanded": "true",
                  "aria-controls": `collapseThirdPartyChannels${_ctx.season.id}`
                }, [...(_cache[7] || (_cache[7] = [
                  _createTextVNode(" Third Party Channels ", -1),
                  _createElementVNode("i", { class: "fa fa-chevron-down ms-2" }, null, -1)
                ]))], 8, _hoisted_34),
                _createElementVNode("div", {
                  id: `collapseThirdPartyChannels${_ctx.season.id}`,
                  class: "accordion-collapse collapse show",
                  "aria-labelledby": `headingThirdPartyChannels${_ctx.season.id}`,
                  "data-bs-parent": `#thirdPartyChannels-listed${_ctx.season.id}`
                }, [
                  (_ctx.thirdPartyChannels.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, " No channels available. "))
                    : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.thirdPartyChannels, (seasonChannel) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "row py-3",
                            key: seasonChannel.channel!.id
                          }, [
                            _createElementVNode("div", _hoisted_38, _toDisplayString(seasonChannel.channel?.description), 1),
                            _createElementVNode("div", _hoisted_39, [
                              _withDirectives(_createElementVNode("select", {
                                class: "form-select",
                                "onUpdate:modelValue": ($event: any) => ((_ctx.getChannelConfig(seasonChannel.channel!.id!).strategyId) = $event),
                                onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.changeSeason && _ctx.changeSeason(...args)))
                              }, [
                                _cache[8] || (_cache[8] = _createElementVNode("option", { value: 0 }, "No strategy applied", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.strategies, (strategy) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: strategy.id,
                                    value: strategy.id
                                  }, _toDisplayString(strategy.name), 9, _hoisted_41))
                                }), 128))
                              ], 40, _hoisted_40), [
                                [_vModelSelect, _ctx.getChannelConfig(seasonChannel.channel!.id!).strategyId]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_42, [
                              _createElementVNode("div", _hoisted_43, [
                                _createElementVNode("div", _hoisted_44, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["input-group-text clickable justify-content-center", {
                                active: !seasonChannel.usePercentage,
                              }]),
                                    onClick: ($event: any) => (_ctx.toggleUsePercentage(seasonChannel, false))
                                  }, "$", 10, _hoisted_45),
                                  _createElementVNode("input", {
                                    type: "text",
                                    class: _normalizeClass(["form-control", {
                                'text-end': seasonChannel.usePercentage,
                                'text-start': !seasonChannel.usePercentage,
                              }]),
                                    value: _ctx.getChannelAdjustmentValue(seasonChannel),
                                    onInput: ($event: any) => (
                                _ctx.updateChannelAdjustment(seasonChannel, $event)
                              )
                                  }, null, 42, _hoisted_46),
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["input-group-text clickable justify-content-center", {
                                active: seasonChannel.usePercentage,
                              }]),
                                    onClick: ($event: any) => (_ctx.toggleUsePercentage(seasonChannel, true))
                                  }, "%", 10, _hoisted_47)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_48, [
                                _createElementVNode("label", null, [
                                  _createElementVNode("em", null, _toDisplayString(_ctx.getAdjustmentValueExplanation(seasonChannel)), 1)
                                ])
                              ])
                            ])
                          ]))
                        }), 128))
                      ]))
                ], 8, _hoisted_35)
              ])
            ], 8, _hoisted_32)
          ])
        ], 8, _hoisted_13)
      ])
    ], 8, _hoisted_2),
    _createVNode(_component_SeasonsCopyComponent, {
      season: _ctx.season,
      existingSeasons: _ctx.existingSeasons,
      courseId: _ctx.courseId,
      onSeasonCopied: _ctx.onSeasonCopied
    }, null, 8, ["season", "existingSeasons", "courseId", "onSeasonCopied"]),
    _createVNode(_component_SeasonsEditComponent, {
      season: _ctx.season,
      existingSeasons: _ctx.existingSeasons,
      onSeasonUpdated: _ctx.onSeasonUpdated
    }, null, 8, ["season", "existingSeasons", "onSeasonUpdated"]),
    _createVNode(_component_QuickAssignModal, {
      seasonId: _ctx.season.id,
      seasonName: _ctx.season.description,
      strategies: _ctx.strategies,
      ownedChannels: _ctx.ownedChannels,
      thirdPartyChannels: _ctx.thirdPartyChannels,
      onApplyAssignment: _ctx.handleApplyAssignment
    }, null, 8, ["seasonId", "seasonName", "strategies", "ownedChannels", "thirdPartyChannels", "onApplyAssignment"])
  ]))
}